import { RiCloseLine, RiSearchLine } from '@remixicon/react';
import qs from 'query-string';
import { useState } from 'react';
import { AgButton, AgInput } from 'src/components/ui';

export function SearchBar() {
  return (
    <form noValidate autoComplete="off" action="/search-results">
      <SearchBarInput />
    </form>
  );
}

export const SearchBarInput = () => {
  const parsed = qs.parse(location.search) || {};
  const query = typeof parsed.query === 'string' ? parsed.query : parsed.query?.join('+');
  const [value, setValue] = useState(query || '');

  return (
    <AgInput
      name="query"
      aria-label="Search"
      placeholder="Search..."
      size="sm"
      value={value}
      onChange={(newValue) => setValue(newValue)}
      wrapperClassName="w-full max-w-[300px]"
      startContent={<RiSearchLine className="h-4 w-4" />}
      endContent={
        value ? (
          <AgButton variant="ghost" size="icon-xs" shape="circle" onPress={() => setValue('')}>
            <RiCloseLine className="h-4 w-4" />
          </AgButton>
        ) : null
      }
    />
  );
};
